.card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: var(--tuna-shape-radius-circle);
  color: inherit;
  transition:
    background-color 120ms ease,
    transform 120ms ease;
}

.card:hover,
.card:focus-visible {
  background-color: var(--tuna-palette-action-hover, rgba(0, 0, 0, 0.08));
}

.card:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.card[data-active='true'] {
  background-color: var(--tuna-palette-action-selected, rgba(0, 0, 0, 0.12));
}

/* Icon rendered inside the Avatar. White stroke for legibility against the
   resolved background color (assumes background is dark enough — material
   500 shades satisfy WCAG AA for white iconography). */
.icon {
  width: 18px;
  height: 18px;
  color: var(--tuna-content-onColor);
}

.indicator {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: var(--tuna-shape-radius-circle);
  border: 2px solid var(--tuna-palette-background-paper);
  pointer-events: none;
}

/* Unread: solid primary dot, bottom-right corner. */
.indicator--unread {
  background-color: var(--tuna-palette-primary-main);
  bottom: 2px;
  right: 2px;
}

/* Error: ringed (hollow with center dot) red, top-right corner. Shape
   differentiates from the unread dot so the cue is not color-only (WCAG
   1.4.1). The corner placement is also distinct so both can coexist. */
.indicator--error {
  background-color: var(--tuna-palette-background-paper);
  border-color: var(--tuna-palette-error-main);
  top: 2px;
  right: 2px;
}

.indicator--error::before {
  content: '';
  position: absolute;
  inset: 1px;
  border-radius: var(--tuna-shape-radius-circle);
  background-color: var(--tuna-palette-error-main);
}

/* Thinking spinner overlays the avatar — a soft pulsing ring. */
.thinking {
  position: absolute;
  inset: -2px;
  border: 2px solid transparent;
  border-top-color: var(--tuna-palette-primary-main);
  border-radius: var(--tuna-shape-radius-circle);
  animation: agent-rail-spin 800ms linear infinite;
  pointer-events: none;
}

@keyframes agent-rail-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Essential motion: data-motion-essential exempts the ring from the global gate, so it slows
 * instead of freezing — a frozen ring reads as a hang. */
@media (prefers-reduced-motion: reduce) {
  .thinking {
    animation-duration: 2400ms;
  }
}
